import { stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object } from 'yup';

const attachDocumentSchema = object().shape({

    documents: array().of(object().shape({
        attachment_key: stringRequiredSchema,
        attachment_name: stringRequiredSchema
    })).min(1, "This field is required."),
    resource_type: stringRequiredSchema
});

export default attachDocumentSchema;